import * as React from 'react';
import Table from "antd/es/table";
import { roles } from "../../../Repository/ContractRepository";
import { Checkbox } from "antd";
import { userHasRole } from "../../../Repository/UserRepository";
import { Role } from "tree-wallet-client";
import { CheckboxChangeEvent } from "antd/es/checkbox";

interface RolesSelectorProps {
  user: any;
  onChange?: Function;
}

export default function RolesSelector(props: RolesSelectorProps) {
  const { user, onChange: onRoleSelection } = props;

  const userRoles = user.contractRoles ? user.contractRoles : [];
  const columns = [
    {
      render: (record: Role) => record.label
    },
    {
      render: (record: Role) => {
        return <Checkbox
          onChange={(e: CheckboxChangeEvent) => onRoleSelection && onRoleSelection(user, record.name, e.target.checked)}
          defaultChecked={userHasRole(userRoles, record.name)}
        />
      }
    },
  ];

  return <div>
    <h3>{user.firstName} {user.lastName} roles</h3>
    <div>
      <Table
        showHeader={false}
        columns={columns}
        pagination={false}
        dataSource={[...Object.values(roles)]}
      />
    </div>
  </div>
}